"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const List = _ref => {
  let {
    data,
    hoverable = false,
    withHeader = true,
    height = '48px',
    className
  } = _ref;
  const keys = Object.keys(data[0]);
  return /*#__PURE__*/React.createElement("table", {
    className: "hpd-list".concat(className ? ' ' + className : '')
  }, withHeader && /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    "aria-hidden": "true"
  }), keys.map(key => /*#__PURE__*/React.createElement("th", {
    key: 'th-' + key
  }, key)))), /*#__PURE__*/React.createElement("tbody", null, data.map(row => /*#__PURE__*/React.createElement("tr", {
    style: {
      height
    },
    className: hoverable ? 'hoverable' : '',
    key: 'tr- ' + row.uuid
  }, /*#__PURE__*/React.createElement("td", {
    "aria-hidden": "true",
    style: {
      width: 0
    }
  }), Object.keys(row).map(key => /*#__PURE__*/React.createElement("td", {
    key: 'td-' + row.uuid + '-' + key
  }, row[key]))))));
};
var _default = exports.default = List;